import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Button, UnreadIndicator } from '@george-labs.com/design-system';
import type { ButtonProps } from '@george-labs.com/design-system/types/components/Button/NewButton';

import styles from './DevToolsDockButton.module.scss';

interface DevToolsDockButtonProps extends ButtonProps {
    className?: string;
    showUnreadIndicator?: boolean;
    showRecordingIndicator?: boolean;
    indicatorClassName?: string;
    indicatorLabel?: string;
}

export const DevToolsDockButton: FunctionComponent<DevToolsDockButtonProps> = ({
    className: classNameProp,
    showUnreadIndicator,
    showRecordingIndicator,
    indicatorClassName: indicatorClassNameProp,
    indicatorLabel,
    ...passThroughProps
}) => {
    const className = classNames(
        'position-relative',
        'justify-content-between',
        'rounded-0',
        'g-fg-text-secondary',
        classNameProp,
    );

    const shouldShowIndicator = showUnreadIndicator || showRecordingIndicator;

    const indicatorClassName = classNames(indicatorClassNameProp, styles.unreadIndicator, {
        [styles.recordingIndicator]: showRecordingIndicator,
    });

    return (
        <Button
            className={className}
            variant={Button.VARIANT.TERTIARY}
            hiddenLabel={Button.HIDDEN_LABEL.ALWAYS}
            fullWidth={Button.FULL_WIDTH.NEVER}
            pill={
                shouldShowIndicator && (
                    <UnreadIndicator className={indicatorClassName} label={indicatorLabel} />
                )
            }
            {...passThroughProps}
        />
    );
};
